import React from 'react'
import FillingSpinner from '../FillingSpinner'
import { TableProps, TableContainerProps } from './types'
import TableContextProvider from 'contexts/TableContext'
import TsxUtils from 'utils/tsx'
import './Table.scss'

const TableContainer: React.FC<TableContainerProps> = ({
  className,
  tableContainerClassName,
  loading,
  sort,
  onSort,
  colgroup,
  children,
}) => (
  <TableContextProvider
    sort={sort}
    onSort={onSort}
  >
    <Table
      className={className}
      tableContainerClassName={tableContainerClassName}
      loading={loading}
      colgroup={colgroup}
    >
      {children}
    </Table>
  </TableContextProvider>
)

const Table: React.FC<TableProps> = ({
  className,
  tableContainerClassName,
  loading,
  colgroup,
  children,
}) => (
  <div
    className={
      'Table__container' + TsxUtils.extraStyle(tableContainerClassName, tableContainerClassName)
    }
  >
    {loading ? (
      <FillingSpinner />
    ) : (
      <table className={'Table' + TsxUtils.extraStyle(className, className)}>
        {colgroup}
        {children}
      </table>
    )}
  </div>
)

export default TableContainer
